import BaseService from '@/ecm/common/BaseService.js';

class AutoImportService {
  baseUrl = 'auto-import';
  getOffice365Token = (userID) => BaseService.get({ url: `${this.baseUrl}/office365/get-token/${userID}` });
  getOneDriveEndpointParameters = () => BaseService.get({ url: `${this.baseUrl}/office365/get-endpoint-parameters` });
  checkFolder = (folder) => BaseService.post({ url: `${this.baseUrl}/filesystem/check-folder`, data: folder })
  createFolderFileSystem = (createFolder) => BaseService.post({ url: `${this.baseUrl}/filesystem/create-folder`, data: createFolder })
  getEmailFolders = (credentials) => BaseService.post({ url: `${this.baseUrl}/email/get-email-folders`, data: credentials })
  checkEmailCredential = (credentials) => BaseService.post({ url: `${this.baseUrl}/email/check-email-credentials`, data: credentials })
  forceAutoImportJob = () => BaseService.post({ url: `${this.baseUrl}/force-autoimport-process` })
  getOffice365EmailFolders = (oAuthToken) => BaseService.post({ url: `${this.baseUrl}/office365/outlook/get-mail-folders`, data: oAuthToken })
}
export default new AutoImportService();
